import { ItemDetails, TimeSlotPicker, WidgetTimePicker } from '../../../redux/types';
import { ShortArticle, WidgetType } from '../../../types/types';

export const makeTimePicker = (picker: WidgetTimePicker): TimeSlotPicker => {
  if (picker) {
    if (picker.widget === WidgetType.FixedDuration) {
      return {
        pickerType: WidgetType.FixedDuration,
        options: picker.durations.map(option => {
          return {
            value: option.slug,
            label: option.label,
          };
        }),
      };
    } else if (picker.widget === WidgetType.FixedHours) {
      return {
        pickerType: WidgetType.FixedHours,
        options: picker.hours.map(option => {
          return {
            value: option.slug,
            label: option.label,
          };
        }),
      };
    }
  }

  return null;
};

export const makeShortArticle = (details: ItemDetails): ShortArticle => {
  const available = details.quantity > 0 && details.netPrice !== null && details.netPrice !== undefined;

  return {
    id: details.id,
    orderItemId: details.orderItemId,
    name: details.name,
    title: details.title,
    description: details.description,
    image: details.image,
    images: details.images,

    available: available,
    quantityInCart: details.quantityInCart,
    minQuantity: details.minQuantity,
    maxQuantity: details.maxQuantity,
    price: {
      gross: details.grossPrice,
      net: details.netPrice,
      priceCalculation: details.priceCalculationType,
    },
    mileageOptions: details.mileageOptions,
    mileageIdInCart: details.mileageIdInCart,
    variation: details.variation,
  };
};
